class CartNotification extends HTMLElement {
	constructor() {
		super();

		this.notification = document.getElementById("cart-notification");
		this.header = document.querySelector("sticky-header");
		this.onBodyClick = this.handleBodyClick.bind(this);

		this.notification.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close());
		this.querySelectorAll('button[type="button"]').forEach((closeButton) => closeButton.addEventListener("click", this.close.bind(this)));
	}

	open() {
		this.notification.classList.add("animate", "active");

		this.notification.addEventListener(
			"transitionend",
			() => {
				this.notification.focus();
				trapFocus(this.notification);
			},
			{ once: true },
		);

		document.body.addEventListener("click", this.onBodyClick);
	}

	close() {
		this.notification.classList.remove("active");
		document.body.removeEventListener("click", this.onBodyClick);

		removeTrapFocus(this.activeElement);
	}

	renderContents(parsedState) {
		this.cartItemKey = parsedState.key;
		this.getSectionsToRender().forEach((section) => {
			const el = document.getElementById(section.id);
			if (!el) return; // ← skip si l'élément n'existe pas sur la page

			const sectionHtml = parsedState.sections?.[section.id];
			if (!sectionHtml) return; // ← skip si la section n'est pas dans la réponse

			const newHtml = this.getSectionInnerHTML(sectionHtml, section.selector);
			if (newHtml) el.innerHTML = newHtml;
		});

		if (this.header) this.header.reveal();
		this.open();
	}

	getSectionsToRender() {
		return [
			{
				id: "cart-icon-bubble",
				selector: "#cart-icon-bubble",
			},
		];
	}

	getSectionInnerHTML(html, selector = ".shopify-section") {
		const parsed = new DOMParser().parseFromString(html, "text/html");
		const el = selector ? parsed.querySelector(selector) : null;
		return el ? el.innerHTML : null; // ← null au lieu de crash
	}

	handleBodyClick(evt) {
		const target = evt.target;
		if (target !== this.notification && !target.closest("cart-notification")) {
			const disclosure = target.closest("details-disclosure, header-menu");
			this.activeElement = disclosure ? disclosure.querySelector("summary") : null;
			this.close();
		}
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.define("cart-notification", CartNotification);
